import { useApiQuery } from 'src/infrastructure/rest-api/useApi';

export const useStorefrontTypesApiQuery = () => {
    const { data, loading, error, refetch } = useApiQuery('/api/storefronttypes', 'get');
    return { data, loading, error, refetch };
};
